module.exports = __webpack_public_path__ + "static/media/syaiwithback.07f2b91a.jpg";